// Status badge color mapping
export const STATUS_STYLES = {
  "Oluşturuldu": "bg-slate-100 text-slate-700 border-slate-200",
  "Satınalmacıya İletildi": "bg-amber-100 text-amber-800 border-amber-200",
  "WhatsApp'a Aktarıldı": "bg-green-100 text-green-800 border-green-200",
  "Mail ile Gönderildi": "bg-sky-100 text-sky-800 border-sky-200",
  "Beklemede": "bg-amber-100 text-amber-800 border-amber-200",
  "Kısmi Sipariş": "bg-cyan-100 text-cyan-800 border-cyan-200",
  "Sipariş Verildi": "bg-blue-100 text-blue-800 border-blue-200",
  "Kontrol Bekliyor": "bg-violet-100 text-violet-800 border-violet-200",
  "Kısmi Geldi": "bg-indigo-100 text-indigo-800 border-indigo-200",
  "İade Bekleniyor": "bg-violet-100 text-violet-800 border-violet-200",
  "Değişim Bekleniyor": "bg-teal-100 text-teal-800 border-teal-200",
  "Tam Geldi": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Kapatıldı": "bg-violet-100 text-violet-800 border-violet-200",
  "İptal": "bg-rose-100 text-rose-800 border-rose-200",
};

export const STATUSES = [
  "Oluşturuldu",
  "Satınalmacıya İletildi",
  "WhatsApp'a Aktarıldı",
  "Mail ile Gönderildi",
  "Beklemede",
  "Kısmi Sipariş",
  "Sipariş Verildi",
  "Kontrol Bekliyor",
  "Kısmi Geldi",
  "İade Bekleniyor",
  "Değişim Bekleniyor",
  "Tam Geldi",
  "Kapatıldı",
  "İptal",
];

export const REASONS = [
  "Müşteri Siparişi",
  "Perakende Satış",
  "Stok Tamamlama",
  "Acil İhtiyaç",
  "Diğer",
];

export function StatusBadge({ status, className = "" }) {
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span data-testid={`status-badge-${status}`} className={`badge-status ${style} ${className}`}>
      {status}
    </span>
  );
}

export function formatDateTime(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("tr-TR", {
    timeZone: "Europe/Istanbul",
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export function formatDate(iso) {
  if (!iso) return "-";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("tr-TR", { timeZone: "Europe/Istanbul", day: "2-digit", month: "2-digit", year: "numeric" });
}
